import Avatar from "@pathwright/ui/src/components/avatar/Avatar"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Text from "@pathwright/ui/src/components/ui/Text"
import FacilitatorAvatarCard from "./FacilitatorAvatarCard"
import "./FacilitatorList.css"
import { getHumanRole, sortByRole } from "./utils"

const FacilitatorList = function (props) {
  const { inverted, staffList, canViewCard, isCurriculum } = props

  const { t } = useTranslate()

  return (
    <div className="FacilitatorList">
      {!isCurriculum && (
        <ul>
          {!!staffList &&
            !!staffList.length &&
            sortByRole(staffList).map((staff, index) => {
              return (
                <li key={index} className="FacilitatorList__item">
                  {canViewCard ? (
                    <FacilitatorAvatarCard
                      size="40px"
                      registration={staff}
                      inverted={inverted}
                      placement="bottom"
                    />
                  ) : (
                    <Avatar user={staff.user} size="40px" />
                  )}
                  <Text.H6 inverted={inverted} style={{ fontSize: "0.875em" }}>
                    {staff.user.display_name}
                  </Text.H6>
                  <Text.Meta inverted={inverted}>
                    {t(`staff_roles.${getHumanRole(staff.role)}`)}
                  </Text.Meta>
                </li>
              )
            })}
        </ul>
      )}
    </div>
  )
}

FacilitatorList.displayName = "FacilitatorList"

export default FacilitatorList
